/**
 *
 * Asynchronously loads the component for EventAddPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const EventAddPage = lazyLoad(
  () => import('./index'),
  module => module.EventAddPage,
);
